// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1hkoL","col":"styles_col__2Z_pK"};